import { DatePickerInput, Flex, Input, SaveText } from '#atoms';
import { PATH } from '#const/path';
import useEditEducationMutation from '#hooks/queries/onboard/useEditEducationMutation';
import useEducationsQuery from '#hooks/queries/onboard/useEducationsQuery';
import { useToast } from '#providers/ToastProvider';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import { useEducationFormState } from '../OnBoardSearchEducation/OnBoardSearchEducation.hooks';

type Inputs = {
  gotAt: Date;
  startAt: Date;
  name: string;
  institution?: string;
  educationIssuerClassId?: string;
  description?: string;
};

export function OnBoardEditEducation() {
  const { educationId } = useParams();

  const { data: educations } = useEducationsQuery();

  // 수정할 경력 선택
  const education = educations?.find(c => c.id === educationId);

  const navigate = useNavigate();
  const { showToast } = useToast();
  const { educationFormState, setEducationFormState } = useEducationFormState();
  const { mutateAsync: editEducation, isLoading } = useEditEducationMutation();
  const { control, handleSubmit, watch, setValue } = useForm<Inputs>({
    mode: 'onSubmit',
    defaultValues: {}
  });

  const [name, institution, gotAt, startAt] = watch([
    'name',
    'institution',
    'gotAt',
    'startAt'
  ]);

  useEffect(() => {
    if (!education) return;

    setValue('name', education.name);
    setValue('institution', education.institution);
    if (education.gotAt) {
      setValue('gotAt', new Date(education.gotAt));
    }
    setValue('startAt', new Date(education.startAt));
  }, [education]);

  /*
    
  */
  const onSubmit = async (data: Inputs) => {
    if (!educationId) return;
    try {
      await editEducation({ id: educationId, args: data });
      navigate(-1);
      setEducationFormState({
        institution: undefined,
        educationIssuerClassId: undefined,
        name: undefined
      });
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '자격증 수정에 실패했습니다.'
      });
    }
  };

  useEffect(() => {
    if (educationFormState.name) {
      setValue('name', educationFormState.name);
    }
    if (educationFormState.educationIssuerClassId) {
      setValue(
        'educationIssuerClassId',
        educationFormState.educationIssuerClassId
      );
    }
    if (educationFormState.institution) {
      setValue('institution', educationFormState.institution);
    }
  }, [educationFormState]);

  return (
    <PrevHeaderBarWithTitleTemplate
      title="교육"
      hasBorder={false}
      ContainerStyle={{ position: 'relative' }}
      defaultBackground
      rightContents={
        <SaveText
          disabled={!(name && institution && gotAt && startAt) || isLoading}
          text="수정"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <div className="p-20">
        <Flex direction="column" gap={32}>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                labelText="교육명"
                placeholder="수료한 교육명을 입력해 주세요"
                type="text"
                required
                value={field.value}
                onClick={() => navigate(PATH.ONBOARD_EDUCATION_SEARCH)}
              />
            )}
          />
          <Controller
            control={control}
            name="institution"
            render={({ field }) => (
              <Input
                labelText="교육기관"
                placeholder="교육기관를 입력해 주세요"
                type="text"
                required
                {...field}
              />
            )}
          />
          {/* <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <Input
                labelText="교육내용"
                placeholder="교육 내용을 간략하게 적어주세요"
                type="text"
                required
                {...field}
              />
            )}
          /> */}
          <Flex direction="column" gap={16}>
            <Flex gap={12}>
              <Controller
                control={control}
                name="startAt"
                render={({ field }) => (
                  <DatePickerInput
                    label="시작 연월"
                    required
                    fullWidth
                    title="시작 연월 선택"
                    placeholder={field.value ? undefined : '시작 연월'}
                    date={field.value}
                    onChange={field.onChange}
                    onlyYearMonth
                  />
                )}
              />
              <Controller
                control={control}
                name="gotAt"
                render={({ field }) => (
                  <DatePickerInput
                    label="종료 연월"
                    required
                    fullWidth
                    title="종료 연월 선택"
                    placeholder={field.value ? undefined : '종료 연월'}
                    date={field.value}
                    onChange={field.onChange}
                    onlyYearMonth
                  />
                )}
              />
            </Flex>
          </Flex>
        </Flex>
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
}
